import { render, staticRenderFns } from "./SpendingChart.vue?vue&type=template&id=65211386&lang=pug"
import script from "./SpendingChart.vue?vue&type=script&lang=js"
export * from "./SpendingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports